import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Autocomplete from '@mui/material/Autocomplete';
import { TreeView } from '@mui/x-tree-view/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { FormControlLabel, Paper } from '@mui/material';
import data from '../add/data.json';
import { getToken } from '../../utils/common';
import logger from '../../utils/logger';

const capitalizeFirst = (str) => {
  const str1 = str.split('_').join(' ');
  return str1.charAt(0).toUpperCase() + str1.slice(1);
};
const bfsSearch = (graph, targetId) => {
  const queue = [...graph];

  while (queue.length > 0) {
    const currNode = queue.shift();
    if (currNode.id === targetId) {
      return currNode;
    }
    if (currNode.children) {
      queue.push(...currNode.children);
    }
  }
  return [];
};

// Helper functions moved to outer scope for better performance
function getAllIds(node, idList = []) {
  idList.push(node.id);
  if (node.children) {
    for (const child of node.children) {
      getAllIds(child, idList);
    }
  }
  return idList;
}

const TextfieldCustom2 = ({
  id = '',
  size = '',
  tittle = '',
  placeholder = '',
  dropdown = [],
  label = '',
  multiline = false,
  value = '',
  changer,
  disabledd = false,
  disable = false,
}) => (
  <Grid item md={size}>
    <Grid container direction={'column'} spacing={0}>
      <Grid item>
        <Typography variant="subtitle2">{tittle}</Typography>
      </Grid>
      <Grid item>
        {dropdown.length === 0 ? null : (
          <Autocomplete
            fullWidth
            size="small"
            key={id}
            disabled={disabledd ? true : disable}
            disablePortal
            value={(dropdown || []).find((e) => e[label] === value)}
            id={id}
            onChange={(event, newValue) => {
              changer(newValue[label]);
            }}
            options={dropdown}
            getOptionLabel={(dropdown) => (dropdown && dropdown[label]) || ''}
            getOptionSelected={(option, selectedValue) => option[label] === selectedValue[label]}
            renderInput={(params) => (
              <TextField
                key={id}
                disabled={disabledd ? true : disable}
                {...params}
                fullWidth
                placeholder={capitalizeFirst(id)}
              />
            )}
          />
        )}
        {dropdown.length === 0 && (
          <TextField
            fullWidth
            id={id}
            disabled={disabledd ? true : disable}
            multiline={multiline}
            name={id}
            size="small"
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              changer(e.target.value);
            }}
          />
        )}
      </Grid>
    </Grid>
  </Grid>
);

export default function Pekerja() {
  const history = useNavigate();
  const location = useLocation();
  // Props destructuring removed as they are not used
  const [id, setid] = React.useState('');

  const [username, setusername] = React.useState('');
  const [disable, setdisabled] = React.useState(true);
  const [email, setemail] = React.useState('');
  const [namalengkap, setnamalengkap] = React.useState('');
  const [nomorponsel, setnomorponsel] = React.useState('');
  const [unitkerja, setunitkerja] = React.useState('');
  const [role, setrole] = React.useState('');
  const [aktif, setaktif] = React.useState('Active');
  const [level, setlevel] = React.useState('Maker');

  const [selectedNodes, setSelectedNodes] = React.useState([]);
  React.useEffect(() => {}, [selectedNodes]);

  // Helper function to check and set node access
  const checkAndSetNodeAccess = (c, cc, accessType) => {
    const hasAccess = location?.state?.index.menu_access.find((e) => e.nama_menu === c.name && e[accessType] === true);
    if (hasAccess && cc.name === accessType) {
      setSelectedNodes((prevSelected) => [...prevSelected, cc.id]);
      return true;
    }
    return false;
  };

  // Helper function to process children nodes
  const processChildrenNodes = (c) => {
    if (c.children === undefined) {
      const data = location?.state?.index.menu_access.find((e) => e.nama_menu === c.name);
      return {
        create: data?.create || false,
        read: data?.read || false,
        update: data?.update || false,
        deleted: data?.delete || false,
      };
    }

    let create = false;
    let read = false;
    let update = false;
    let deleted = false;

    for (const cc of c.children) {
      create = checkAndSetNodeAccess(c, cc, 'create') || create;
      read = checkAndSetNodeAccess(c, cc, 'read') || read;
      update = checkAndSetNodeAccess(c, cc, 'update') || update;
      deleted = checkAndSetNodeAccess(c, cc, 'delete') || deleted;
    }

    return { create, read, update, deleted };
  };

  React.useEffect(() => {
    setusername(location?.state?.index.username);
    setemail(location?.state?.index.email);
    setnamalengkap(location?.state?.index.nama_lengkap);
    setnomorponsel(location?.state?.index.phone);
    setunitkerja(location?.state?.index.work_unit);
    setrole(location?.state?.index.role);
    setaktif(location?.state?.index.is_active ? 'Active' : 'inActive');
    setlevel(location?.state?.index.level ? 'Maker' : 'Approval');
    setid(location?.state?.index.id);

    for (const c of data) {
      const { create, read, update, deleted } = processChildrenNodes(c);

      if (
        location?.state?.index.menu_access.find((e) => e.nama_menu === c.name) &&
        (create || read || update || deleted)
      ) {
        setSelectedNodes((prevSelected) => [...prevSelected, c.id]);
      }
    }
  }, []);

  function handledis() {
    setdisabled(!disable);
  }

  const getAllChild = (id) => getAllIds(bfsSearch(data, id));

  const getAllFathers = (id, list = []) => {
    const node = bfsSearch(data, id);
    if (node.parent) {
      list.push(node.parent);

      return getAllFathers(node.parent, list);
    }

    return list;
  };

  function isAllChildrenChecked(node, list) {
    const allChild = getAllChild(node.id);
    const nodeIdIndex = allChild.indexOf(node.id);
    allChild.splice(nodeIdIndex, 1);

    return allChild.every((nodeId) => selectedNodes.concat(list).includes(nodeId));
  }

  const handleNodeSelect = (event, nodeId) => {
    event.stopPropagation();
    const allChild = getAllChild(nodeId);
    const fathers = getAllFathers(nodeId);

    if (selectedNodes.includes(nodeId)) {
      setSelectedNodes((prevSelectedNodes) => prevSelectedNodes.filter((id) => !allChild.concat(fathers).includes(id)));
    } else {
      const ToBeChecked = allChild;

      setSelectedNodes((prevSelectedNodes) => [...prevSelectedNodes].concat(ToBeChecked));
    }
  };

  const handleExpandClick = (event) => {
    event.stopPropagation();
  };

  const renderTree = (nodes) => (
    <Grid item xs={6}>
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        onClick={handleExpandClick}
        label={
          <>
            <Checkbox
              disabled={disable}
              checked={selectedNodes.indexOf(nodes.id) !== -1}
              tabIndex={-1}
              disableRipple
              onClick={(event) => handleNodeSelect(event, nodes.id)}
            />
            {nodes.name}
          </>
        }
      >
        {Array.isArray(nodes.children) ? nodes.children.map((node, _i) => renderTree(node)) : null}
      </TreeItem>
    </Grid>
  );

  const postData = async () => {
    const payload = location?.state?.index.menu_access;
    const payload2 = [];
    let payloadd;
    data.map((c, i) => {
      let create = false;
      let read = false;
      let update = false;
      let deleted = false;
      if (selectedNodes.find((e) => e === c.id && c.id === '1')) {
        create = true;
        read = true;
        update = true;
        deleted = true;
      }
      if (selectedNodes.find((e) => e === c.id && c.id === '99')) {
        create = true;
        read = true;
        update = true;
        deleted = true;
      }
      if (c.children !== undefined) {
        c.children.map((ca, ii) => {
          if (selectedNodes.find((e) => e === ca.id)) {
            switch (ca.name) {
              case 'Create':
                create = true;
                break;
              case 'Read':
                read = true;
                break;
              case 'Update':
                update = true;
                break;
              case 'Delete':
                deleted = true;
                break;
              default:
            }
          }
          payloadd = {
            nama_menu: c.name,
            create,
            update,
            delete: deleted,
            read,
          };

          return ca;
        });
        payload2.push({
          nama_menu: c.name,
          create,
          update,
          delete: deleted,
          read,
        });
      } else {
        payloadd = {
          nama_menu: c.name,
          create,
          update,
          delete: deleted,
          read,
        };
        payload2.push(payloadd);
      }

      return c;
    });

    const uniqueData = payload2.reduce((result, item) => {
      if (!result.some((existingItem) => existingItem.nama_menu === item.nama_menu)) {
        result.push(item);
      }
      return result;
    }, []);
    const item = {
      id,
      email,
      menu_access: uniqueData,
      username,
      nama_lengkap: namalengkap,
      phone: nomorponsel,
      work_unit: unitkerja,
      role,
      is_active: aktif === 'Active',
      level,
    };
    try {
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}user/edit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(item),
      });

      const data = await response.json();
      alert(data.error_message || data.message);
    } catch (error) {
      logger.error('Error:', error);
    }
    history('/dashboard/user');
  };
  const hapus = async () => {
    const payload = location?.state?.index.menu_access;

    let payloadd;
    data.map((c, i) => {
      let create = false;
      let read = false;
      let update = false;
      let deleted = false;
      if (selectedNodes.find((e) => e === c.id && c.id === '1')) {
        create = true;
        read = true;
        update = true;
        deleted = true;
      }
      if (c.children !== undefined) {
        c.children.map((ca, ii) => {
          if (selectedNodes.find((e) => e === ca.id)) {
            switch (ca.name) {
              case 'Create':
                create = true;
                break;
              case 'Read':
                read = true;
                break;
              case 'Update':
                update = true;
                break;
              case 'Delete':
                deleted = true;
                break;
              default:
            }
          }
          payloadd = {
            nama_menu: c.name,
            create,
            update,
            delete: deleted,
            read,
          };
          return ca;
        });
      } else {
        payloadd = {
          nama_menu: c.name,
          create,
          update,
          delete: deleted,
          read,
        };
      }
      payload.push({
        nama_menu: c.name,
        create,
        update,
        delete: deleted,
        read,
      });
      return c;
    });
    const item = {
      id,
    };

    try {
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}user/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(item),
      });

      const data = await response.json();
      alert(data.error_message || data.message);
    } catch (error) {
      logger.error('Error:', error);
    }
    history('/dashboard/user');
  };
  React.useEffect(() => {}, []);

  return (
    <span>
      {/* <pre style={{ textAlign: "left" }}>{JSON.stringify(formik, null, 2)}</pre> */}
      {/* style={{ padding: 20, height: "80vh" }} */}
      <Paper
        style={{
          padding: 20,
          minHeight: '80vh',
          backgroundColor: '#fafafc',
          boxShadow: 'none',
        }}
      >
        <Grid container direction={'row'} spacing={2}>
          {TextfieldCustom2({
            id: 'username',
            size: 6,
            tittle: 'Username',
            dropdown: '',
            placeholder: 'Username',
            value: username,
            changer: setusername,
            disable: disable,
            disabledd: true,
          })}
          {TextfieldCustom2({
            id: 'email',
            size: 6,
            tittle: 'Email',
            dropdown: '',
            placeholder: 'Email@gmail.com',
            value: email,
            changer: setemail,
            disable: disable,
            disabledd: true,
          })}
          {TextfieldCustom2({
            id: 'namalengkap',
            size: 6,
            dropdown: '',
            tittle: 'Full Name',
            placeholder: 'Full Name',
            value: namalengkap,
            changer: setnamalengkap,
            disable: disable,
          })}
          {TextfieldCustom2({
            id: 'nomorponsel',
            size: 6,
            dropdown: '',
            tittle: 'Phone Number',
            placeholder: '08122323',
            value: nomorponsel,
            changer: setnomorponsel,
            disable: disable,
          })}
          {TextfieldCustom2({
            id: 'unitkerja',
            size: 6,
            tittle: 'Work Unit',
            dropdown: '',
            placeholder: 'Management',
            value: unitkerja,
            changer: setunitkerja,
            disable: disable,
          })}
          {TextfieldCustom2({
            id: 'role',
            size: 6,
            tittle: 'Role',
            dropdown: '',
            placeholder: 'Supervisor',
            value: role,
            changer: setrole,
            disable: disable,
          })}
          {}
          <Grid item xs={12}>
            <Typography>Menu Access</Typography>
          </Grid>
          <Grid item xs={12}>
            <TreeView
              multiSelect
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
              selected={selectedNodes}
            >
              <Grid container direction={'row'} xs={12}>
                {data?.map((node) => renderTree(node))}
              </Grid>
            </TreeView>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">Status</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue={aktif}
                onChange={(e) => setaktif(e.target.value)}
              >
                <FormControlLabel disabled={disable} value="Active" control={<Radio />} label="Active" />
                <FormControlLabel disabled={disable} value="inActive" control={<Radio />} label="inActive" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">Level Access</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue={level}
                onChange={(e) => setlevel(e.target.value)}
              >
                <FormControlLabel disabled={disable} value="Maker" control={<Radio />} label="Maker" />
                <FormControlLabel disabled={disable} value="Approval" control={<Radio />} label="Approver" />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid
            item
            container
            direction={'row'}
            style={{ textAlignLast: 'right', placeContent: 'flex-end' }}
            spacing={2}
          >
            <Grid item>
              <Button
                variant="contained"
                style={{
                  textTransform: 'none',
                  backgroundColor: 'red',
                }}
                onClick={disable ? hapus : handledis}
              >
                {disable ? ' Delete User' : 'Cancel'}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                style={{
                  textTransform: 'none',
                  backgroundColor: 'green',
                }}
                onClick={disable ? handledis : postData}
              >
                {disable ? 'Edit User' : 'Submit'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </span>
  );
}

TextfieldCustom2.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  tittle: PropTypes.string,
  placeholder: PropTypes.string,
  dropdown: PropTypes.array,
  label: PropTypes.string,
  multiline: PropTypes.bool,
  value: PropTypes.string,
  changer: PropTypes.func,
  disabledd: PropTypes.bool,
  disable: PropTypes.bool,
};
